import React from 'react';
const stats = [['2500+', 'Maestri di Tennis in tutta Italia'], ['6 + 5', 'Volumi e bonus esclusivi'], ['4.9/5', 'Valutazione media dei professionisti'], ['Ogni giorno', 'Per elevare lo standard del tuo Club']];
const notes = [['“Ho pianificato l’intera stagione del Mini-Tennis in una sola sera. Ora ogni lezione ha un obiettivo chiaro e i genitori notano finalmente la differenza.”', 'Marco R.', 'Istruttore Nazionale · Milano'], ['“I miei allievi agonisti migliorano più velocemente perché seguiamo una progressione logica. Ha cambiato il mio modo di gestire la scuola.”', 'Stefano B.', 'Direttore Tecnico · Roma']];
export function ProofSection() {
  return <section className="bg-[#101a12] px-5 pb-16" data-id="element-192" data-mp="3nqd1l22r9icv">
      <div className="mx-auto max-w-6xl" data-id="element-193" data-mp="3nt928y5zml50">
        <div className="grid grid-cols-2 border border-emerald-300/25 bg-[#1b2b1e] sm:grid-cols-4" data-id="element-194" data-mp="3srk9r28t8jk2">
          {stats.map(([value, label]) => <div key={label} className="border-b border-r border-emerald-300/15 px-4 py-6 text-center last:border-r-0 sm:border-b-0" data-id="element-195" data-mp="1i3l5vatkoz4">
              <p className="font-display text-4xl font-bold uppercase text-emerald-300 sm:text-5xl" data-id="element-196" data-mp="10mu48l43x6k2">
                {value}
              </p>
              <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-slate-300" data-id="element-197" data-mp="ro09l0ac6q95">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-198" data-mp="1ofu4mdhepoxx">
          {notes.map(([quote, name, role]) => <figure key={name} className="flex flex-col border border-emerald-950/10 bg-white p-6" data-id="element-199" data-mp="1eo6ims3md03u">
              <div className="mb-4 text-emerald-700" aria-label="5 stelle su 5" data-id="element-200" data-mp="1aljo2jfkd12y">
                ★★★★★
              </div>
              <blockquote className="flex-1 text-sm font-medium italic leading-relaxed text-[#102016]" data-id="element-201" data-mp="275sacmxqf5ye">
                {quote}
              </blockquote>
              <figcaption className="mt-5 border-t border-emerald-950/10 pt-4 text-sm font-bold text-[#102016]" data-id="element-202" data-mp="fp0htti7s1e">
                {name}
                <span className="ml-2 text-xs font-medium text-slate-600" data-id="element-203" data-mp="5es6bghb62af">
                  {role}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}